import compact from 'lodash/compact';
import range from 'lodash/range';
import sortBy from 'lodash/sortBy';
import values from 'lodash/values';

import getAppendPreviewRequest from './getAppendPreviewRequest';
import getNormalRequest from './getNormalRequest';

export interface GetTrackLineRequestsOptions {
    includeAppendPreviewLine?: boolean;
    interaction?: InteractionState | undefined;
    project: MapProject;
    track: Track;
}

function getDraggingLocalId(interaction: InteractionState | undefined) {
    if (!interaction) return undefined;
    else if (interaction.subtype === 'draggingPoint') return interaction.pointLocalId;
    else if (interaction.subtype === 'dragging') return interaction.waypoint.properties.localId;
}

export function getTrackLineRequests({
    interaction,
    project,
    track,
    includeAppendPreviewLine = false,
}: GetTrackLineRequestsOptions): TrackLineRequest[] {
    if (!track.isGeometryLoaded) return [];

    // Tracks and imported routes do not have points
    if (
        track.unmodifiedLine &&
        (track.properties.track_type !== 'route' || values(track.points).length === 0)
    ) {
        return [
            {
                type: 'sync',
                geometry: track.unmodifiedLine.geometry,
                properties: track.unmodifiedLine.properties,
            },
        ];
    }

    const points = sortBy(
        values(track.points).filter(
            (point) => !point.properties.archived && !point.properties.deleted
        ),
        (point) => point.properties.order
    );

    const draggingLocalId = getDraggingLocalId(interaction);

    const lines = range(Math.max(points.length - 1, 0)).map((index: number) => {
        const fromPoint = points[index];
        const toPoint = points[index + 1];

        return getNormalRequest({
            track,
            project,
            fromPoint,
            toPoint,
            draggingLocalId,
        });
    });

    return compact([
        ...lines,
        includeAppendPreviewLine && getAppendPreviewRequest(track, interaction, project),
    ]);
}
